import React, {useEffect, useState, useRef, useContext} from "react";
import {store} from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


import {LICENCE_KEY} from "../constants/charts";

//am4core.useTheme(am4themes_animated);
am4core.addLicense(LICENCE_KEY);

export default function AmChartSimpleBar({chartId, chartData, categoryKey, valueKey, color, width, height, positiveNegative, colorNegative, 
	onClick, additionalSeries, additionalSeriesColor, colorKey}){

	const chart = useRef(null);
	const globalState = useContext(store);
	
	useEffect(() => {
		if(chartData && chartData.length > 0){
			loadChart();
		}
		
	}, [chartData, valueKey]);
	
	const loadChart = () => {
		let x = am4core.create(chartId, am4charts.XYChart);
		x.tooltip.label.fontSize = 8;
		x.paddingRight = 20;
		x.stroke = 'white';
		x.strokeOpacity = 0;
  
    x.fontSize = 8;
    x.fill='white';
    x.strokeAlpha=0;
    
    let container = am4core.create("container", am4core.Container);
    container.background.strokeWidth = 0;
    container.background.stroke = am4core.color("#999");
   
		let categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.inversed=true;
		categoryAxis.dataFields.category=categoryKey;	
		
		categoryAxis.renderer.minGridDistance = 15;
		categoryAxis.strokeWidth=0;
		categoryAxis.renderer.grid.template.strokeOpacity = 0;
		categoryAxis.renderer.grid.template.strokeDasharray = "1,3";
		
		categoryAxis.renderer.labels.template.fontSize=9;
		categoryAxis.renderer.labels.template.strokeOpacity=0;
		categoryAxis.renderer.labels.template.fillOpacity=1;
		categoryAxis.renderer.labels.template.fill='black';
		categoryAxis.renderer.labels.template.rotation=0;
		//categoryAxis.renderer.labels.template.location = 0;
		categoryAxis.renderer.labels.template.horizontalCenter = "right";
		
		categoryAxis.renderer.axisFills.template.disabled = false;
		categoryAxis.renderer.axisFills.template.fillOpacity = 0.1;
		categoryAxis.renderer.axisFills.template.fill = "grey";
		categoryAxis.renderer.axisFills.template.strokeOpacity = 0;
		categoryAxis.renderer.minGridDistance = 1;
		categoryAxis.renderer.cellStartLocation = 0.2;
		categoryAxis.renderer.cellEndLocation = 0.8;
		
    
		let valueAxis = x.xAxes.push(new am4charts.ValueAxis());
 		valueAxis.strokeWidth=0;
 		valueAxis.renderer.labels.template.fill='black';
 		valueAxis.renderer.labels.template.fontSize=9;
 		valueAxis.renderer.grid.template.strokeOpacity = 0;
 	
 		let series = x.series.push(new am4charts.ColumnSeries());
  	
    
  	if(additionalSeries){
  		let series1 = x.series.push(new am4charts.ColumnSeries());
	  	series1.columns.template.tooltipText = "{categoryY}: {valueX.value}";
	  	series1.columns.template.column.cornerRadiusBottomRight = 0;
	  	series1.columns.template.column.cornerRadiusTopRight = 5;
	  	series1.columns.template.column.cornerRadiusBottomLeft = 0;
	  	series1.columns.template.column.cornerRadiusTopLeft = 5;
	  	series1.columns.template.width = am4core.percent(50);
	  	series1.columns.template.adapter.add("fill", function(fill, target){
	    	return additionalSeriesColor;
	    });
	    series1.dataFields.categoryX = categoryKey;
    	series1.dataFields.valueY = additionalSeries;
    	series1.strokeWidth=0;
  	}
    
    series.columns.template.events.on("hit", function(event) {
			onClick(event.target.dataItem.dataContext.id);
		});
    
    x.numberFormatter.numberFormat = "#.00a";
		x.numberFormatter.bigNumberPrefixes = [
			{"number":1e+3, "suffix":"K"},
			{"number":1e+6, "suffix":"M"},
			{"number":1e+9, "suffix":"Bn"}
		];
		
		
		
		series.columns.template.tooltipText = "{categoryY}: {valueX.value}";
		series.columns.template.tooltipFontSize = 9;
    series.dataFields.categoryY = categoryKey;
    series.dataFields.valueX = valueKey;
    series.columns.template.width = 20;
    series.strokeWidth=0;
    series.columns.template.column.cornerRadiusBottomRight = 5;
	  series.columns.template.column.cornerRadiusTopRight = 5;
	  series.columns.template.column.cornerRadiusBottomLeft = 5;
	  series.columns.template.column.cornerRadiusTopLeft = 5;
	  series.columns.template.fillOpacity = 0.8;
    
    if(color){
    	series.columns.template.adapter.add("fill", function(fill, target){
				return color
			});
    }
    
		
		x.data = chartData;
		let scrollbar = new am4core.Scrollbar();
		scrollbar.opacity = 0.2;
		//x.scrollbarX = scrollbar;
		chart.current = x;
		
		return () => {
			x.dispose();
		};
	};	
		
	return (
		<div id={chartId} style={{ width: width, height: height}}></div>
	);
}